import { AI_IMAGE_TYPE_OPTIONS } from "../constants";
import { AiImageModelSelect } from "./ai-image-model-select";
import { AiImageSelect } from "./ai-image-select";

export const AiImageSettings = () => {
  return (
    <div className="tw-flex tw-items-center tw-z-1 tw-gap-0.5 tw-p-1">
      <AiImageSelect
        options={AI_IMAGE_TYPE_OPTIONS}
        type="types"
        icon="ri-image-line"
        default="image"
      />
      <AiImageModelSelect />
    </div>
  );
};
